<template>
    <div>
        <div class="row">
            <div class="col-md-12 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Ignore words when searching for near duplicates</div>

                    <div class="panel-body">
                        Currently showing up to {{show_num}} words from the beginning and end of the page (select more if needed):
                        <el-slider
                                v-model="show_num"
                                :min="50"
                                :max="1000"
                                :marks="marks"
                                style="margin-left:100px;margin-right:100px;margin-bottom:20px;"
                                :step="50"
                                show-stops
                        >
                        </el-slider>
                        <p>Skipping <b>{{skip_start}}</b> words at the beginning of each page</p>
                        <span v-for="(word, index) in start_text">
                            <span v-if="index<skip_start" class="ignored" @click="change_skip_start(index)">{{word}}
                                <span class="label">{{index+1}}</span>
                            </span>
                            <span v-else class="labeled" @click="change_skip_start(index)">{{word}}
                                <span class="label">{{index+1}}</span>
                            </span>
                        </span>
                        <div>...</div>
                        <p>Skipping the last <b>{{skip_end}}</b> words at the end of each page</p>

                        <span v-for="(word, index) in end_text">
                            <span v-if="index<end_text.length-skip_end" class="labeled" @click="change_skip_end(index)">{{word}}
                                <span class="label">{{end_text.length-index}}</span>
                            </span>
                            <span v-else class="ignored" @click="change_skip_end(index)">{{word}}
                                <span class="label">{{end_text.length-index}}</span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            start_text: function () {
                let length = this.text.length
                if (length<this.show_start+this.show_end) {
                    return this.text.slice(0,length/2)
                }
                return this.text.slice(0, this.show_start)
            },
            end_text: function () {
                let length = this.text.length
                if (length<this.show_start+this.show_end) {
                    return this.text.slice(length/2,length)
                }
                return this.text.slice(length - this.show_end, length)
            },
            show_start: function () {
                return this.show_num
            },
            show_end: function () {
                return this.show_num
            },
        },
        mounted() {
            axios.get('/rot/text_as_array/' + this.extent_id + '/' + this.asset_id)
                .then(response => {
                    this.text = response.data
                })
                .catch(error => {
                    console.log('oops getting array of text')
                })
        },
        methods: {
            change_skip_start(index) {
                console.log(index)
                this.skip_start = index + 1
            },
            change_skip_end(index) {
                console.log(index)
                this.skip_end = this.end_text.length - index
            },
        },
        props: ['asset_id','extent_id'],
        data() {
            return {
                text: [],
                skip_start: 2,
                skip_end: 1,
                show_num: 100,
                marks: {
                    10: "10 words",
                    100: "100 words",
                    200: "200 words",
                    500: "500 words",
                    1000: "1,000"
                }
            }
        }
    }
</script>